function attachImageEvents() {
  setTimeout(() => {
    const images = document.querySelectorAll('.cd-product-item-image');
    images.forEach(img => {
      img.addEventListener('click', function(event) {
        event.preventDefault(); // Chặn hành động mặc định (chuyển trang)
        openModal(event.target.src);
      });
    });
  }, 0);
}

function handleAtc(){
  window.OpusATCSelector = ['button[type="submit"].product-form--atc-button']
}



// Mở modal và hiển thị ảnh toàn màn hình
function openModal(imageSrc) {
  const modal = document.getElementById('imageModal');
  const modalImg = document.getElementById('modalImage');

  modal.style.display = 'flex'; // Hiển thị modal
  modalImg.src = imageSrc; // Gán ảnh được nhấn vào modal
  modalImg.style.transform = 'scale(1)'; // Reset zoom level
}

// Đóng modal khi nhấn nút X hoặc ngoài modal
function closeModal() {
  document.getElementById('imageModal').style.display = 'none';
}

// Zoom ảnh khi click vào ảnh trong modal
function zoomImage(event) {
  const modalImg = document.getElementById('modalImage');
  const currentScale = modalImg.style.transform.match(/scale\((\d+(\.\d+)?)\)/);
  let scale = currentScale ? parseFloat(currentScale[1]) : 1;
  
  if (event.deltaY < 0) {
    scale += 0.1; // Zoom in
  } else if (event.deltaY > 0 && scale > 1) {
    scale -= 0.1; // Zoom out
  }

  modalImg.style.transform = `scale(${scale})`;
}

// Đóng modal khi click ra ngoài modal
window.onclick = function(event) {
  const modal = document.getElementById('imageModal');
  if (event.target === modal) {
    closeModal();
  }
};

// Gán sự kiện cuộn chuột để zoom ảnh
document.getElementById('modalImage')?.addEventListener?.('wheel', zoomImage);
attachImageEvents();
handleAtc();




